export default {
  methods: {
    getTablePermissions(tableName) {
      const tables = JSON.parse(localStorage.getItem('tables'));
      const currentTable = tables.find(t => t.name === tableName);
      if (currentTable) {
        return currentTable.permissions;
      }
      return [];
    }
  }
};
